var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Overview } from '@shared-ui/retail-activities-overview';
import { UitkSpacing } from 'uitk-react-spacing';
import { keyboardFocusProps } from '../../../utils/accessibility';
import { useStores } from '../../../utils/hooks';
import { ACTIVITY_DETAILS_BATCHING } from '../../../constants';
export var ActivityOverview = function () {
  var _a = useStores(),
    activityDetailStore = _a.activityDetailStore,
    _b = _a.detailCriteriaStore,
    activityId = _b.activityId,
    _c = _b.detailVariables,
    detailsViewOptions = _c.detailsViewOptions,
    dateRange = _c.dateRange;
  var sectionRef = activityDetailStore.activityDetail.activity.sectionRef;
  return React.createElement("div", __assign({
    className: "uitk-view-row-theme-primary"
  }, keyboardFocusProps(sectionRef)), React.createElement(UitkSpacing, {
    padding: {
      large: {
        inline: 'three'
      },
      small: {
        block: 'three'
      }
    }
  }, React.createElement("div", null, React.createElement(Overview, {
    inputs: {
      activityId: activityId,
      dateRange: dateRange,
      detailsViewOptions: detailsViewOptions
    },
    batchKey: ACTIVITY_DETAILS_BATCHING
  }))));
};